import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  NOTIFICATION_CONFIG,
  NOTIFICATION_EVENTS,
  NOTIFICATION_LISTS_ID,
  NOTIFICATION_MODAL_TYPE
} from "../../../../constants/NotificationConstants";
import { Component, Prop, Watch, Vue, Inject } from "vue-property-decorator";
import Vuetify from "vuetify";
import TimeSelection from "@/shared/components/TimeSelection/TimeSelection.vue";
import { NotificationConfig } from "@/modules/Notification/models/NotificationConfig";
import { FieldChannels } from "../../model/FieldChannels";
import { ListService } from "@/modules/List/services/ListService";
import { Http } from "@status/codes";
import { ListOption } from "../../model/ListOption";
import { PreventKey } from "@/shared/mixins/mixins";
import { FILTERS_NAMES_CONST } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";

Vue.use(Vuetify);

@Component({
  name: "InitialConfiguration",
  components: {
    TimeSelection
  }
})
export default class InitialConfiguration extends PreventKey {
  @Inject() listService!: ListService;

  @Prop({ default: 0 }) reset!: number;
  @Prop({ default: false }) isEditing!: boolean;
  @Prop({ default: 0 }) editingEvent!: number;
  @Prop() fields!: FieldChannels;
  @Prop({ default: false }) isDocument!: boolean;
  @Prop({ default: false }) tracing!: boolean;
  @Prop({ default: false }) isScheduledAvailable!: boolean;
  @Prop({ default: "" }) notificationModalType!: string;
  @Prop({ default: false }) canEditRestrictedField!: boolean;
  @Prop() notificationConfig!: NotificationConfig;
  @Prop({ default: false }) isMappingData!: boolean;
  @Prop({ default: "" }) collection!: string;
  NAME_LABEL = NOTIFICATION_CONFIG.LABEL.NAME;
  NAME_HINT = NOTIFICATION_CONFIG.HINT.NAME;
  CHANNEL_LABEL = NOTIFICATION_CONFIG.LABEL.CHANNEL;
  CHANNEL_HINT = NOTIFICATION_CONFIG.HINT.CHANNEL;
  MSG_TYPE_LABEL = NOTIFICATION_CONFIG.LABEL.MSG_TYPE;
  MSG_CATEGORY_LABEL = NOTIFICATION_CONFIG.LABEL.MSG_CATEGORY;
  MSG_TYPE_HINT = NOTIFICATION_CONFIG.HINT.MSG_TYPE;
  MSG_CATEGORY_HINT = NOTIFICATION_CONFIG.HINT.MSG_CATEGORY;
  TIME_LABEL = NOTIFICATION_CONFIG.LABEL.TIME;
  TIME_HINT = NOTIFICATION_CONFIG.HINT.TIME;
  START_DATE_LABEL = NOTIFICATION_CONFIG.LABEL.START_DATE;
  BEFORE_DATE_LABEL = NOTIFICATION_CONFIG.LABEL.BEFORE_DATE;
  START_DATE_HINT = NOTIFICATION_CONFIG.HINT.START_DATE;
  BEFORE_DATE_HINT = NOTIFICATION_CONFIG.HINT.BEFORE_DATE;
  FREQUENCY_LABEL = NOTIFICATION_CONFIG.LABEL.FREQUENCY;
  FREQUENCY_HINT = NOTIFICATION_CONFIG.HINT.FREQUENCY;
  TIMES_LABEL = NOTIFICATION_CONFIG.LABEL.TIMES;
  TIMES_HINT = NOTIFICATION_CONFIG.HINT.TIMES;
  IMEDIATE_LABEL = NOTIFICATION_CONFIG.LABEL.IMEDIATE_LABEL;
  REMINDER_LABEL = NOTIFICATION_CONFIG.LABEL.REMINDER_LABEL;
  SAVE_NOTIFICATION = NOTIFICATION_MODAL_TYPE.SAVE;
  SUBJECT_LABEL = NOTIFICATION_CONFIG.LABEL.NAME;
  MEDICAL_APPOINTMENT_COLLECTION = FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.NAME;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  primaryButtonClass = STYLE_CLASSES.PRIMARY_BTN;
  channels: { name: string; value: string; key: string }[] = [];
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  requiredSelectedOne = [this.selectAtLeastOne()];
  numberField = [FORM_VALIDATORS.REQUIRED_NUMBER_FIELD];
  naturalNumberField = [FORM_VALIDATORS.REQUIRED_NATURAL_NUMBER_FIELD];
  requiereNaturalNumber = [
    FORM_VALIDATORS.REQUIRED_NATURAL_NUMBER_FIELD,
    FORM_VALIDATORS.REQUIRED_FIELD
  ];

  messagesTypes = NOTIFICATION_CONFIG.MSG_TYPES;
  messagesCategories: Array<ListOption> = [];

  loadingInitial = false;
  name = "";
  time = "";
  resetTimeSel = 0;
  startDate: number | null = null;
  frequency: number | null = null;
  times: number | null = null;
  channelsChosen: string[] = [];
  messageType = "";
  messageCategory = "";
  editingNotification: NotificationConfig = {} as NotificationConfig;
  isScheduledNotification = true;
  isReminderNotification = false;
  removedDuplicateWhatsapp = false;

  async mounted() {
    await this.getChannels();
    this.messagesCategories = await this.getNotificationCategories();
    if (this.isEditing) {
      this.editNotification();
    }
  }

  async getChannels() {
    try {
      await this.listService
        .getListOptionsByName("CANALES NOTIFICACIONES")
        .then(response => {
          if (response.code == Http.Found) {
            this.channels =
              (response.data?.map(item => ({
                name: item.title,
                value: item.value,
                key: item.id
              })) as { name: string; value: string; key: string }[]) ?? [];
          }
        });
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  @Watch("isReminderNotification")
  handleReminderNotification() {
    this.$emit(NOTIFICATION_EVENTS.REMINDER, this.isReminderNotification);
  }

  @Watch("isScheduledNotification")
  updatedInmediate() {
    this.time = "";
    this.startDate = 0;
    this.resetTimeSel = 1 - this.resetTimeSel;
    this.$emit(
      NOTIFICATION_EVENTS.UPDATE_INMEDIATE,
      this.isScheduledNotification
    );
  }

  @Watch("editingEvent")
  editNotification() {
    if (this.isEditing) {
      this.loadingInitial = true;
      this.mapNotificationData();
      this.$emit(NOTIFICATION_EVENTS.MAPPED.INITIAL_CONFIGURATION);
      this.loadingInitial = false;
    }
  }

  selectAtLeastOne(): (value: string) => boolean | string {
    return () =>
      this.channelsChosen.length > 0 || NOTIFICATION_CONFIG.SELECT_CHANNEL;
  }

  @Watch("reset")
  resetNotification() {
    if (!this.isMappingData) {
      if (this.isEditing) {
        this.mapNotificationData();
      } else {
        this.clearNotificationData();
      }
    }
  }

  mapNotificationData() {
    this.name = this.notificationConfig.name ?? "";
    this.time = this.notificationConfig.time ?? "";
    this.startDate = this.notificationConfig.startDate ?? null;
    this.frequency = this.notificationConfig.notification.frequency ?? null;
    this.times = this.notificationConfig.notification.times ?? null;
    this.channelsChosen = this.mapChannelsChosen() as string[];
    this.messageType = this.notificationConfig.notification.message.type ?? "";
    this.messageCategory =
      this.notificationConfig.notification.message.category ?? "";
    this.isScheduledNotification =
      this.notificationConfig.notification.isScheduledNotification || false;
    this.resetTimeSel = 1 - this.resetTimeSel;
    this.isReminderNotification =
      this.notificationConfig.notification.isReminder || false;
  }

  mapChannelsChosen() {
    if (!this.notificationConfig.notification.channelsKeys) {
      return this.notificationConfig.notification.channels ?? [];
    }
    return this.notificationConfig.notification.channelsKeys.map(
      key => key.value
    );
  }

  clearNotificationData() {
    this.name = "";
    this.time = "";
    this.startDate = null;
    this.frequency = null;
    this.times = null;
    this.channelsChosen = [];
    this.messageType = "";
    this.isScheduledNotification = false;
    this.resetTimeSel = 1 - this.resetTimeSel;
  }

  @Watch("name")
  updatedName() {
    if (!this.isMappingData) {
      this.$emit(NOTIFICATION_EVENTS.UPDATE.NAME, this.name);
    }
  }

  removeDuplicateWhatsapp() {
    const seen = new Set();
    this.channelsChosen = this.channelsChosen.filter(channel => {
      const key = this.channels.find(ch => ch.value === channel)?.key;
      if (key === NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP) {
        if (seen.has(key)) {
          Snackbar.popError(FORM_MESSAGES.WHATSAPP_DUPLICATE);
          this.removedDuplicateWhatsapp = true;
          return false; // don't include duplicate
        }
        seen.add(key);
      }
      return true;
    });
  }

  @Watch("channelsChosen", { deep: true })
  updatedChannels() {
    if (this.removedDuplicateWhatsapp) {
      this.removedDuplicateWhatsapp = false;
      return;
    }
    if (!this.isMappingData) {
      const whatsappFields =
        this.channelsChosen.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP
        ) ||
        this.channelsChosen.includes(
          NOTIFICATION_CONFIG.CHANNEL_TEXT.WHATSAPP2
        );
      console.log("whatsappFields", whatsappFields);
      const smsFields = this.channelsChosen.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.SMS
      );
      const pushFields = this.channelsChosen.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.PUSH
      );
      const emailFields = this.channelsChosen.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.EMAIL
      );
      const webhookFields = this.channelsChosen.includes(
        NOTIFICATION_CONFIG.CHANNEL_TEXT.WEBHOOK
      );
      if (this.isDocument) {
        this.messageType = NOTIFICATION_CONFIG.MSG_TYPES[1].value;
      } else {
        this.messageType = NOTIFICATION_CONFIG.MSG_TYPES[0].value;
        this.messageCategory = NOTIFICATION_CONFIG.MSG_CATEGORIES[0].value;
      }

      const channelsChosenKeys = this.getChannelsChosenKeys();

      this.$emit(
        NOTIFICATION_EVENTS.UPDATE.CHANNELS,
        this.getChannelsChosen(),
        whatsappFields,
        smsFields,
        pushFields,
        emailFields,
        webhookFields,
        channelsChosenKeys
      );
    }
  }

  getChannelsChosenKeys() {
    return this.channels.filter(channel =>
      this.channelsChosen.includes(channel.value)
    );
  }

  getChannelsChosen() {
    return this.channels
      .filter(channel => this.channelsChosen.includes(channel.value))
      .map(channel => channel.key);
  }

  @Watch("fields", { deep: true })
  @Watch("isDocument")
  messageTypeUpdate() {
    if (!this.isMappingData) {
      if (this.isDocument) {
        this.isScheduledNotification = true;
        this.messageType = NOTIFICATION_CONFIG.MSG_TYPES[1].value;
        this.messagesTypes = [NOTIFICATION_CONFIG.MSG_TYPES[1]];
      } else {
        this.messageType = NOTIFICATION_CONFIG.MSG_TYPES[0].value;
        if (!(this.fields.smsFields || this.fields.pushFields)) {
          this.messagesTypes = NOTIFICATION_CONFIG.MSG_TYPES;
        } else {
          this.messagesTypes = [NOTIFICATION_CONFIG.MSG_TYPES[0]];
        }
      }
    }
  }

  @Watch("messageType", { deep: true })
  updatedMessageType() {
    if (!this.isMappingData) {
      this.$emit(NOTIFICATION_EVENTS.UPDATE.MESSAGE_TYPE, this.messageType);
    }
  }

  @Watch("messageCategory", { deep: true })
  updatedMessageCategory() {
    if (!this.isMappingData) {
      this.$emit(
        NOTIFICATION_EVENTS.UPDATE.MESSAGE_CATEGORY,
        this.messageCategory
      );
    }
  }

  updatedTime(time: string) {
    this.time = time;
    this.$emit(NOTIFICATION_EVENTS.UPDATE.TIME, this.time);
  }

  @Watch("startDate")
  updatedDate() {
    if (!this.isMappingData) {
      this.$emit(NOTIFICATION_EVENTS.UPDATE.DATE, this.startDate);
    }
  }

  @Watch("frequency")
  updatedFrequency() {
    if (!this.isMappingData) {
      this.$emit(NOTIFICATION_EVENTS.UPDATE.FREQUENCY, this.frequency);
    }
  }
  @Watch("times")
  updatedTimes() {
    if (!this.isMappingData) {
      this.$emit(NOTIFICATION_EVENTS.UPDATE.TIMES, this.times);
    }
  }

  async getNotificationCategories(): Promise<Array<ListOption>> {
    try {
      const response = await this.listService.getListById(
        NOTIFICATION_LISTS_ID.CATEGORIES
      );

      if (response.code !== Http.Found) {
        return NOTIFICATION_CONFIG.MSG_CATEGORIES;
      }

      const options: Array<ListOption> = [];

      response.data?.optionsSchema.forEach(item => {
        options.push({
          name: item.const,
          value: item.title
        });
      });

      return options;
    } catch (err) {
      return NOTIFICATION_CONFIG.MSG_CATEGORIES;
    }
  }
}
